// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"888":"265eaa0475165c00abef","937":"27919c58c501fa970454"}[chunkId] + ".css";
};